import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../../i18n/lang";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); if (hreflang) el.setAttribute("hreflang", hreflang); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

export const useSeo = (title, description) => {
  const { lang } = useLang();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!title) return;
    document.title = title;
    document.documentElement.lang = lang;
    setMeta("name", "description", description || "");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:locale", lang === "it" ? "it_IT" : "en_GB");
    const origin = window.location.origin;
    const rest = pathname.replace(/^\/(en|it)/, "");
    setLink("canonical", `${origin}${pathname}`);
    setLink("alternate", `${origin}/en${rest}`, "en");
    setLink("alternate", `${origin}/it${rest}`, "it");
  }, [title, description, lang, pathname]);
};
